import getInstanceAxios from "../request"
const baseDomain = process.env.NEXT_PUBLIC_TRACKING
const baseURL = `${baseDomain}/`

export default getInstanceAxios(baseURL, false)
